import { apiClient } from './client';
// Client Company API functions
export const clientCompanyApi = {
    // Get company by ID
    getById: (id) => apiClient.get(`/api/clientcompanies/${id}`),
    // Update company
    update: (clientCompanyId, company) => apiClient.put(`/api/ClientCompanies/${clientCompanyId}`, company),
    // Get customers managed by a company (full view DTOs with workspaces)
    getCustomersManagedByCompany: (companyId) => apiClient.get(`/api/ClientCompanies/${companyId}/Customers`),
    // Create a new client company (returns ClientCompanyViewDto)
    create: (managingClientCompanyId, payload) => apiClient.post(`/api/ClientCompanies/${managingClientCompanyId}/Customers`, payload),
    // Scrape company website (Firecrawl pipeline: scrape, vectorize, update company)
    scrapeWebsite: (companyId, url) => {
        const query = url ? `?url=${encodeURIComponent(url)}` : '';
        return apiClient.post(`/api/companies/${companyId}/scrape${query}`, {});
    },
    // Check whether a proposed ClientCompany slug is globally available.
    checkSlug: (slug) => apiClient.get(`/api/ClientCompanies/CheckSlug?slug=${encodeURIComponent(slug)}`),
};
